import type { GroupConfigMinimal } from 'services/API/GroupConfigurationAPI';

const SCOUT_AGENT_SOURCE: GroupConfigMinimal['source'] = 'scoutbot';

/**
 * Saved searches created via a Scout chat prompt (source: "scoutbot") are
 * edited entirely through the chat, not the filter editor.
 */
export const isChatCreatedSavedSearch = (
  group: GroupConfigMinimal | null | undefined,
): boolean => {
  return group?.source === SCOUT_AGENT_SOURCE;
};
